import * as angular from "angular";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";

let HomePageComponent = {
    selector: "vcHomePage",
    templateUrl: "/angular/components/home/home-page.component.html",
    bindings: {},
    controller: class ErrorResultsController {
        public permissionProvider: PermissionCheck;
        public dashboardsPermission: boolean;
        public navigationBarService: NavigationBarHelperService;
        public user: User;

        constructor(
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider,
            NavigationBarHelperService: NavigationBarHelperService
        ) {
            this.permissionProvider = PermissionCheck;
            this.user = UserDataProvider.getActiveUser();

            this.permissionProvider.getFeaturePermissions().then(() => {
                this.dashboardsPermission =
                    this.permissionProvider.hasPermission("DASHBOARDS_PAGE");
                if (!this.dashboardsPermission) {
                    NavigationBarHelperService.selectedPage.navbar = "white";
                    NavigationBarHelperService.selectedPage.navborder = true;
                }
            });
        }
    },
};

angular
    .module("home", [])
    .component(HomePageComponent.selector, HomePageComponent);
